const interfacePhrases = {
    rate_limited: 'Omezení četnosti',
    limit_exceeded: 'Překročení limitu',
    used: 'Použití',
    identifier: 'Identifikátor',
    verification: 'Ověření',
    messages: 'Zprávy',
    data: 'Data',
    custom: 'Vlastní',
    management_api: 'Rozhraní správy {{product}}',
    management_api_role_description: 'Tato vestavěná role poskytuje přístup k rozhraní správy.',
    client_credentials: 'Přihlašovací údaje klienta',
    authentication_request: 'Požadavek na ověření',
    callback: 'Zpětné volání ověření',
    help_title: 'Centrum nápovědy iden',
    help_subtitle: 'Nápověda bez opuštění pracovní plochy',
    open_help: 'Otevřít celou stránku nápovědy',
    close_help: 'Zavřít nápovědu',
    about: 'O aplikaci a otevřeném zdroji',
    open_navigation: 'Otevřít navigaci',
    close_navigation: 'Zavřít navigaci',
    development_enabled: 'Vývojové funkce povoleny',
    beta: 'Beta',
    impersonation: 'Zastupování uživatele',
    key: 'Klíč',
    value: 'Hodnota',
    error: 'Chyba',
    details: 'Technické podrobnosti',
    callback_failed: 'Návrat z přihlášení se nepodařilo dokončit.',
    back_sign_in: 'Zpět na přihlášení',
    powered_by: 'Využívá technologii',
    avatar: 'Avatar',
    logo: 'Logo',
    qr_code: 'QR kód',
    sample_title: 'Chcete vidět příklad?',
    sample_description: 'Prohlédněte si ukázkovou aplikaci využívající tento návod.',
    sample_action: 'Zobrazit příklad',
    further_readings: 'Další informace',
    complete_guide: 'Úplný návod',
    custom_domains_notice: 'Po přidání <a>vlastních domén</a> můžete použít tento koncový bod: <code>{{endpoint}}</code>.',
    my_project: 'Můj projekt',
    my_secret: 'Můj tajný klíč',
    my_token: 'Můj token',
    role_example: 'Čtenář',
    reset_retry: 'Obnovit konfiguraci a zkusit znovu',
    open_dev_panel: 'Otevřít panel vývojáře',
    close_dev_panel: 'Zavřít panel vývojáře',
    configuration: 'Konfigurace',
    app_id: 'ID aplikace',
    extra_parameters: 'Další parametry přihlášení',
    prompt: 'Výzva k ověření',
    scope: 'Rozsah',
    resource: 'Prostředek',
    resources_space_delimited: 'Prostředky (oddělené mezerami)',
    sign_out_to_apply: 'Pro použití změn se odhlaste.',
    refresh_token_grant: 'Autorizace obnovovacím tokenem',
    organization_id: 'ID organizace',
    console_result: 'Výsledek najdete v konzoli prohlížeče.',
    request_token: 'Vyžádat token',
    user_info: 'Informace o uživateli',
    get_id_token_claims: 'Získat údaje z tokenu identity',
    fetch_user_info: 'Načíst informace o uživateli',
    device_initializing: 'Inicializace autorizace zařízení…',
    device_success: 'Úspěšně jste se přihlásili do ukázkové aplikace.',
    sign_in_information: 'Vaše přihlašovací informace:',
    email: 'E-mail',
    username: 'Uživatelské jméno',
    user_id: 'ID uživatele',
    sign_out_demo: 'Odhlásit se z ukázky',
    device_expired: 'Kód zařízení vypršel',
    generic_error: 'Došlo k chybě',
    device_expired_description: 'Kód zařízení vypršel. Zkuste to znovu a získáte nový kód.',
    sign_in_title: 'Přihlaste se ke svému účtu',
    scan_instruction: 'Naskenujte QR kód nebo otevřete tuto adresu na jiném zařízení:',
    one_time_code: 'Zadejte jednorázový kód',
    token_info: 'Informace o tokenu',
    get_access_token: 'Získat přístupový token',
    context_unavailable: 'Informace o účtu se nepodařilo načíst.',
    not_initialized: 'Informace o účtu nejsou inicializovány.',
    not_set: 'Nenastaveno',
    configured: 'Nakonfigurováno',
    password: 'Heslo',
    phone: 'Telefonní číslo',
    search_help: 'Hledat v nápovědě',
    language: 'Jazyk',
    menu: 'Nabídka',
    compatibility_notice: 'Kompatibilita: zděděné názvy SDK, balíčků, protokolů, komponent a hlaviček požadavků Logto zůstávají beze změny.',
    source: 'Zdroj',
    upstream_repository: 'Původní repozitář',
    current_fork: 'Aktuální repozitář',
    license_notice: 'iden vychází z Logto, otevřeného softwaru licencovaného pod Mozilla Public License 2.0.',
    about_description: 'Informace o produktu a otevřeném zdroji.',
    page_not_found: 'Stránka nenalezena',
    page_not_found_description: 'Tato stránka není dostupná. Pokračujte návratem do centra nápovědy.',
    introduction: 'Úvod',
    quick_starts: 'Rychlý začátek',
    integration: 'Integrace',
    end_user_flows: 'Postupy koncových uživatelů',
    authorization: 'Autorizace',
    user_management: 'Správa uživatelů',
    security: 'Zabezpečení',
    customization: 'Přizpůsobení',
    connectors: 'Konektory',
    organizations: 'Organizace',
    self_hosting: 'Vlastní hosting',
    continue: 'Pokračovat',
    loading: 'Načítání…',
    save: 'Uložit',
    saved: 'Uloženo',
    try_again: 'Zkusit znovu',
    client_id: 'ID klienta',
    client_secret: 'Tajný klíč klienta',
    redirect_uri: 'URI přesměrování',
    status: 'Stav',
    type: 'Typ',
    permissions: 'Oprávnění',
    token_data: 'Data tokenu',
    context_data: 'Data kontextu',
    jwt_extra_claims: 'Další údaje tokenu',
    action_result: 'Výsledek akce',
    social_account_already_linked: 'Tento sociální účet je již propojený.',
};
export default Object.freeze(interfacePhrases);
